import {COLORS} from 'core/styles';

export let container = {
    backgroundColor: '#fff',
    padding: '30px',
    textAlign: 'center',
};

export let message = {
    margin: '10px auto 15px',
    textAlign: 'left',
    paddingBottom: '15px',
    color: COLORS.grayFont,
    fontWeight: 400,
    borderBottom: `1px solid ${COLORS.grayLight}`,
};

export let input = {
    maxWidth: '200px',
    margin: '0 auto',
};

export let loading = {
    maxWidth: '25px',
};

export let error = {
    textAlign: 'left',
    fontWeight: 'bold',
    color: COLORS.danger,
    marginBottom: '15px',
};

export let success = {
    textAlign: 'left',
    fontWeight: 'bold',
    color: COLORS.successAlt,
    marginBottom: '15px',
};

export let reason = {
};

export let warning = {
    marginBottom: '15px',
    width: '40px',
};

export const warningText = {
    color: COLORS.warning,
    fontWeight: 'bold',
    margin: '10px auto 15px',
    textAlign: 'left',
    paddingBottom: '15px',
};